export default "__VITE_ASSET__f88efa49__"